import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { IBalanceItem } from './balances-item-interface';
import { companyItemImgPath } from 'app/services/companyItems/company-items.interface';

@Component({
  selector: 'balances-item',
  templateUrl: './balances-item.component.html',
  styleUrls: ['./balances-item.component.scss']
})
export class BalancesItemComponent implements OnChanges {

  @Input() data: IBalanceItem;
  @Input() isFocus: boolean = false;
  @Output() onItemClick: EventEmitter<string> = new EventEmitter<string>();

  ngOnChanges(changes: SimpleChanges): void {
    if (this.data && !this.data.image) this.data.image = companyItemImgPath()[this.data.id];
    if (this.data && !this.data.balance) this.data.balance = 0;

  }

  itemClick() {
    this.onItemClick.emit(this.data.key);
  }
}